import { Component, ContentChild, ContentChildren, Directive, Input, QueryList, TemplateRef } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Directive({
  selector: '[gcStepsHeaderLabel]',
  standalone: false,
})
export class StepsHeaderLabelDirective {
  @ContentChild(TemplateRef, { static: true }) content: TemplateRef<any>;
}

@Directive({
  selector: '[gcStepsHeaderComplete]',
  standalone: false,
})
export class StepsHeaderCompleteDirective {
  @ContentChild(TemplateRef, { static: true }) content: TemplateRef<any>;
}

@Component({
  selector: 'gc-steps-header-step',
  template: '<ng-template><ng-content></ng-content></ng-template>',
  standalone: false,
})
export class StepsHeaderStepComponent {
  @Input() label: string;
  @Input() complete = false;
  @ContentChild(StepsHeaderLabelDirective, { static: true })
  private readonly labelContent: StepsHeaderLabelDirective;

  get _labelTemplate(): TemplateRef<any> {
    return this.labelContent ? this.labelContent.content : null;
  }
}

@Component({
  selector: 'gc-steps-header',
  templateUrl: './steps-header.component.html',
  styleUrls: ['./steps-header.component.scss'],
  standalone: false,
})
export class StepsHeaderComponent {
  @ContentChildren(StepsHeaderStepComponent) steps: QueryList<StepsHeaderStepComponent>;
  @ContentChild(StepsHeaderCompleteDirective, { static: true })
  completeContent: StepsHeaderCompleteDirective;
  @Input() colour: ThemePalette = 'primary';
  @Input() selectedIndex = 0;
}
